import { User } from '@bulthaup/api/db';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

type RouterContext = {
  user: User | null;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
});
